/**
 * Placeholder view for binary file types we don't decode in the browser.
 *
 * For PDFs and images we embed the raw stream directly. For weights / .so /
 * .o files we just show size + MIME so the reviewer can decide whether to
 * download them.
 */
export default function BinaryViewer(props: {
  mime: string | null;
  sizeBytes: number;
  rawUrl: string;
}) {
  const { mime, sizeBytes, rawUrl } = props;
  if (mime === "application/pdf") {
    return <embed src={rawUrl} type="application/pdf" className="h-full w-full" />;
  }
  if (mime?.startsWith("image/")) {
    return (
      <div className="flex h-full items-center justify-center bg-ink-100">
        <img src={rawUrl} alt="" className="max-h-full max-w-full" />
      </div>
    );
  }
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 text-sm text-ink-500">
      <div>Binary file · {mime ?? "unknown type"} · {kib(sizeBytes)}</div>
      <a className="text-ink-700 underline" href={rawUrl} download>
        Download
      </a>
    </div>
  );
}

function kib(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KiB`;
  return `${(n / 1024 / 1024).toFixed(2)} MiB`;
}
